export enum ModalActionListEnum {
  OPEN = 'modal:open',
  CLOSE = 'modal:close',
}
